import React, { forwardRef, useCallback, useMemo } from 'react'
import { DocumentBlacklineSegment } from '../../shared/interfaces/project/document/blackline/document-blackline.interface'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectSelectedBlacklineSegment,
  setSelectedBlacklineSegment,
} from '../../redux/viewer-slice'
interface PageOverlayBlacklineProps {
  blacklineSegment: DocumentBlacklineSegment
  coords: {
    width: number
    height: number
    topOffset: number
    leftOffset: number
  }
  shouldElevate: boolean
}

const PageOverlayBlackline = forwardRef<
  HTMLButtonElement,
  PageOverlayBlacklineProps
>(({ blacklineSegment, coords, shouldElevate }, ref) => {
  const dispatch = useDispatch()
  const selectedBlacklineSegment = useSelector(selectSelectedBlacklineSegment)
  const bgColor = useMemo(() => {
    if (selectedBlacklineSegment?.id === blacklineSegment.id) {
      return 'bg-yellow-500'
    }
    switch (blacklineSegment?.match_type) {
      case 0:
        return 'bg-blue-500'
      case 1:
        return 'bg-yellow-500'
      case 2:
        return 'bg-red-500'
      default:
        return 'bg-gray-500'
    }
  }, [
    blacklineSegment.id,
    blacklineSegment?.match_type,
    selectedBlacklineSegment?.id,
  ])

  const onClickBlacklineSegment = useCallback(() => {
    dispatch(setSelectedBlacklineSegment(blacklineSegment))
  }, [blacklineSegment, dispatch])

  return (
    <button
      id={`${blacklineSegment.id}`}
      ref={ref}
      className={`absolute ${bgColor} opacity-10 ${
        shouldElevate ? 'z-50' : 'z-30'
      }`}
      onClick={onClickBlacklineSegment}
      style={{
        width: `${coords.width}%`,
        height: `${coords.height}%`,
        top: `${coords.topOffset}%`,
        left: `${coords.leftOffset}px`,
      }}
    />
  )
})

PageOverlayBlackline.displayName = 'PageOverlayBlackline'

export default PageOverlayBlackline
